// Device detection for network-level Watch Now routing
export function detectDevice() {
  if (typeof window === "undefined") return "unknown";
  const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
  const platform = (navigator.platform || "").toLowerCase();

  // iPad on iPadOS 13+ reports MacIntel with touch support
  const isIpad =
    /ipad/.test(ua) ||
    (platform === "macintel" && (navigator.maxTouchPoints || 0) > 1);
  if (isIpad) return "ipad";
  if (/iphone|ipod/.test(ua)) return "ios";

  if (/android/.test(ua)) return "android";
  if (/roku/.test(ua)) return "roku";
  if (/silk|kindle|afts|aftm|aftb|firetv|fire tv/.test(ua)) return "firetv";
  if (/mac|windows|linux|cros/.test(ua) || platform.length) return "desktop";

  return "unknown";
}

// Public config — populate only when official URLs are supplied
export const WATCH_DESTINATIONS = {
  APPLE_APP_URL: "https://apps.apple.com/us/app/your-channel-network/id1609222546",
  GOOGLE_PLAY_URL: "",
  ROKU_CHANNEL_URL: "",
  FIRE_TV_URL: "",
  WEB_PLAYER_URL: "",
};

// Map detected device → destination key
const DEVICE_TO_KEY = {
  ios: "APPLE_APP_URL",
  ipad: "APPLE_APP_URL",
  android: "GOOGLE_PLAY_URL",
  roku: "ROKU_CHANNEL_URL",
  firetv: "FIRE_TV_URL",
  desktop: "WEB_PLAYER_URL",
};

// Return {url, key} if a direct destination is configured; else null → caller opens modal.
export function resolveWatchDestination(device = detectDevice()) {
  const key = DEVICE_TO_KEY[device];
  const url = key ? WATCH_DESTINATIONS[key] : "";
  return url ? { url, key, device } : null;
}

// List of platforms with configured URLs (for the modal).
export function getConfiguredPlatforms() {
  const meta = [
    { key: "APPLE_APP_URL", label: "Apple App Store", sub: "iPhone · iPad" },
    { key: "GOOGLE_PLAY_URL", label: "Google Play", sub: "Android" },
    { key: "ROKU_CHANNEL_URL", label: "Roku Channel", sub: "Roku" },
    { key: "FIRE_TV_URL", label: "Amazon Fire TV", sub: "Fire TV" },
    { key: "WEB_PLAYER_URL", label: "Watch on the Web", sub: "Any browser" },
  ];
  return meta.filter((m) => WATCH_DESTINATIONS[m.key]);
}
